import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { Observable, Subject, takeUntil } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class AuthGuardOkta {
  constructor(
    private featureTogglesFacade: FeatureTogglesFacade,
    private router: Router,
  ) {}
  isAuthGuardToggleOn: boolean;
  isAuthGuardEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isAuthGuardEnabled',
  ]);
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    this.isAuthGuardEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isAuthGuardEnabled) => {
        this.isAuthGuardToggleOn = isAuthGuardEnabled;
      });
    if (this.isAuthGuardToggleOn) {
      return true;
    }
    // eslint-disable-next-line no-else-return
    else {
      this.router.navigate(['/secure/home']);
      return false;
    }
  }
}
